import React from 'react';
import { Container, Card, Button, Alert, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { PENDING_CHECKOUT_KEY } from './checkoutConstants';
import PageHeading from '../PageHeading';

class CheckoutCancel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: null,
      status: null,
    };
  }

  componentDidMount() {
    this.cancelPendingCheckout();
  }

  getOrderId = () => {
    const params = new URLSearchParams(this.props.location.search);
    return (
      params.get('order') ||
      (typeof sessionStorage !== 'undefined'
        ? sessionStorage.getItem(PENDING_CHECKOUT_KEY)
        : null)
    );
  };

  cancelPendingCheckout = async () => {
    const orderId = this.getOrderId();
    if (!orderId) {
      this.setState({
        loading: false,
        status: 'canceled',
        error: null,
      });
      return;
    }

    try {
      const res = await axios.post(`/api/checkout/${orderId}/cancel`);
      if (typeof sessionStorage !== 'undefined') {
        sessionStorage.removeItem(PENDING_CHECKOUT_KEY);
      }
      this.setState({ loading: false, status: 'canceled', error: null });
      void res;
    } catch (err) {
      const message =
        (err.response && err.response.data && err.response.data.error) ||
        'Unable to cancel checkout.';
      const status =
        err.response && err.response.data && err.response.data.status;
      if (typeof sessionStorage !== 'undefined') {
        sessionStorage.removeItem(PENDING_CHECKOUT_KEY);
      }
      this.setState({
        loading: false,
        error: status === 'paid' ? null : message,
        status: status || 'canceled',
      });
    }
  };

  render() {
    const { loading, error, status } = this.state;

    return (
      <Container className="pad-t R-clm">
        <PageHeading as="h2" icon="cancel">
          Checkout canceled
        </PageHeading>
        <Card border="light" className="Form pad2">
          {loading ? (
            <div className="text-center">
              <Spinner animation="border" role="status" />
              <p className="mt-3">Updating your order…</p>
            </div>
          ) : status === 'paid' ? (
            <>
              <Alert variant="success">
                This order was already paid. View confirmation instead.
              </Alert>
              <Button
                as={Link}
                to={`/checkout/success?order=${this.getOrderId() || ''}`}
                variant="success"
              >
                View order
              </Button>
            </>
          ) : (
            <>
              {error && <Alert variant="warning">{error}</Alert>}
              <Alert variant="secondary">
                Payment was not completed. Your bag is unchanged.
              </Alert>
              <Button as={Link} to="/shopping-cart" variant="success">
                Return to bag
              </Button>
            </>
          )}
        </Card>
      </Container>
    );
  }
}

export default CheckoutCancel;
